import { disableBodyScroll, enableBodyScroll } from "//auriccosmetics.com/cdn/shop/t/55/assets/body_scroll_lock.js?v=61507118286993660021774881917";
import { EscapeObserver } from "//auriccosmetics.com/cdn/shop/t/55/assets/escapeObserver.js?v=40787582539029033611774881917";

const MENU_BUTTON_CLASSNAME = 'menu-button';
const MENU_ASIDE_CLASSNAME = 'menu-aside';
const MENU_ASIDE_CONTENT_CLASSNAME = 'menu-aside__content';
const MENU_ASIDE_MENU_BUTTON_CLASSNAME = 'menu-aside__menu-button';
const MENU_ASIDE_SCREEN_WRAPPER_CLASSNAME = 'menu-aside__screen-wrapper';

const menu_button = document.querySelectorAll(`.${MENU_BUTTON_CLASSNAME}`);
const menuAside = document.querySelector(`.${MENU_ASIDE_CLASSNAME}`);
const menuAsideContent = document.querySelector(`.${MENU_ASIDE_CONTENT_CLASSNAME}`);
const menuAsideMenuButton = document.querySelector(`.${MENU_ASIDE_MENU_BUTTON_CLASSNAME}`);
const screenWrapper = document.querySelector(`.${MENU_ASIDE_SCREEN_WRAPPER_CLASSNAME}`);

let isMenuOpened = false;
let closeTimeout = null;

const close = () => {
  clearTimeout(closeTimeout);

  menu_button.forEach(element => {
    element.classList.remove('open');
  });

  menuAside.classList.remove('open');
  screenWrapper.classList.remove('show');
  menuAsideMenuButton.style.visibility = 'hidden';

  screenWrapper.removeEventListener('click', close);
  enableBodyScroll(menuAsideContent, {reserveScrollBarGap: true});
  isMenuOpened = false;

  closeTimeout = setTimeout(() => {
    menuAside.style.visibility = 'hidden';
  }, 500);
};

const open = () => {
  clearTimeout(closeTimeout);

  menu_button.forEach(element => {
    element.classList.add('open');
  });

  menuAside.classList.add('open');
  menuAside.style.visibility = 'visible';
  screenWrapper.classList.add('show');
  menuAsideMenuButton.style.visibility = 'visible';

  screenWrapper.addEventListener('click', close);
  disableBodyScroll(menuAsideContent, {reserveScrollBarGap: true});
  isMenuOpened = true;

  setTimeout(() => {
    $(menuAside).find(`.${MENU_BUTTON_CLASSNAME}`).focus();
  }, 100);
};


const handleClick = () => {
  if (isMenuOpened) {
    close();
  } else {
    open();
  }
};

menu_button.forEach(element => element.addEventListener('click', handleClick));

EscapeObserver.onEscape(close);

// Auto open the button on reload. Useful when testing the menu
// $(() => {
//   open();
// });